<template>
  <v-card v-if="showTextBlock" class="encounter-card" :height="minHeight">
    <div class="encounter-card-scrim">
      <span class="encounter-card-title">{{ encounter.encounterType.name }}</span>
      <span class="encounter-card-description">{{ displayDescription }}</span>
    </div>
  </v-card>
</template>

<style scoped>
.encounter-card {
  overflow-y: auto;
  background: transparent !important;
  box-shadow: none !important;
}
@media (min-width: 960px) {
  .encounter-card {
    height: 400px !important;
  }
}
.encounter-card-scrim {
  padding: 16px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0) 100%);
  display: flex;
  flex-direction: column;
}
.encounter-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
  display: block;
  margin-bottom: 8px;
}
.encounter-card-description {
  font-size: 14.5px;
  line-height: 1.5;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
}
</style>

<script>
// TOP varianta encounter.encounterType.textPosition (viz docs/superpowers/
// specs/2026-09-07-encounter-fullscreen-fe-design.md) - jmeno+text v
// jednom bloku nahore, obrazek uz zije v BattleScreen.vue's pozadi (viz
// Task 4), ne v týhle kartě. BOTTOM variantu resi EncounterActions.vue
// (text nad tlacitky) - v tom rezimu tahle komponenta nerenderuje nic.
// Podminka je zamerne "neni BOTTOM" (ne "je TOP") - neznama/chybna hodnota
// textPosition musi bezpecne spadnout na TOP, ne tise zmizet (nalez final
// review).
export default {
  name: 'EncounterCard',
  props: {
    encounter: {type: Object, default: null},
    minHeight: {type: [Number, String], default: 400},
  },
  computed: {
    showTextBlock() {
      return !!(this.encounter && this.encounter.encounterType && this.encounter.encounterType.textPosition !== 'BOTTOM');
    },
    // Jakmile je akce encounteru dokoncena (napr. ITEM_HANDOFF escorted),
    // ukaze se completedDescription (podekovani/potvrzeni odmeny) misto
    // puvodni description - pokud ho encounter typ ma nastaveny, jinak
    // beze zmeny (encounter typy bez vicefazoveho prubehu).
    completed() {
      return !!(this.encounter && this.encounter.data && this.encounter.data.escorted === true);
    },
    displayDescription() {
      if (this.completed && this.encounter.encounterType.completedDescription) {
        return this.encounter.encounterType.completedDescription;
      }
      return this.encounter.encounterType.description;
    },
  },
}
</script>
